import { Button, Grid, InputLabel, MenuItem, Select, TextField, Typography } from '@material-ui/core'
import { Opacity } from '@material-ui/icons'
import React, { useEffect, useState } from 'react'
import firebase from "firebase";
function UrediRaspored(props) {
    const {obj,indx,closeModal,setRasporedToShow,day,rasporedToShow} = props

    const [prijavaState, setPrijavaState] = useState(obj)

    const[time,setTime] = useState(prijavaState.time)
    const[type,setType] = useState(prijavaState.type)
    
    const[maxGuests,setMaxGuests] = useState(prijavaState.max_guests)
    
    const[name,setName] = useState(prijavaState.name)
    
    const[IDPredavac,setIDpredavaca] = useState(prijavaState.id_predavaca)
        
    const[length,setLength] = useState(prijavaState.length)

            
    const[lokacija,setLokacija] = useState(prijavaState.lokacija)
    
    const submitChanges = ()=>{  

        let newState = prijavaState;
        newState.time =time;
        newState.type = type;
        newState.max_guests= maxGuests;
        newState.name = name;
        newState.id_predavaca = IDPredavac;
        newState.length = length;
        newState.lokacija = lokacija;

        
        setPrijavaState(newState)
        let index = indx
        if(indx==null){
            index =  firebase.database().ref().child('EditPage/raspored/'+day+'/').push().key
        }
        var updates = {};
        updates['EditPage/raspored/'+day+'/' + index] = newState;
        firebase.database().ref().update(updates);


        let newRaspored = rasporedToShow;
        newRaspored[index] = newState;

        setRasporedToShow(newRaspored)
        closeModal()
    }



    return (
        <div
        style={{
            backgroundColor:"white",
            border:"5px solid lightblue",
            width:"100%",
            padding:"20px"
           
        }}
        >
            <Grid container
                direction="column"
                style={{width:"100%"}}
            >
                <Grid item>
                    <TextField
                    style={{width:"50%"}}
                    label="Vrijeme Pocetka"
                    type="time"
                    onChange={(e)=>{setTime(e.target.value)}}
                    value={time}
                    required
                    >
                    </TextField>
                </Grid>
                <Grid item>
                <Select
                style={{width:"50%"}}
                    labelId="demo-simple-select-filled-label"
                    id="demo-simple-select-filled"
                    value={type}
                    required
                    onChange={(e)=>{
                        setType(e.target.value)
                        switch(e.target.value){
                            case "predavanje":
                                setLength(45)
                                break;
                            case "k_radionica":
                                setLength(30)
                                break;
                            case "d_radionica":
                                setLength(60)
                                break
                        }
                    }}
                    >
                    <InputLabel style={{width:"50%"}} id="demo-simple-select-filled-label">Tip predavanja  ({length} min)</InputLabel>
                    <MenuItem label="Tip predavanja" value="" style={{width:"50%"}}>
                        <em>None</em>
                    </MenuItem>
                    <MenuItem value={"predavanje"}>Predavanje</MenuItem>
                    <MenuItem value={"k_radionica"}>Kratka Radionica</MenuItem>
                    <MenuItem value={"d_radionica"}>Duga Radionica</MenuItem>
                    </Select>
                    
                </Grid>
                <Grid item>
                    <TextField
                    style={{width:"50%"}}
                    label="Maksimalni broj gostiju"
                    type="number"
                    required
                    onChange={(e)=>{setMaxGuests(e.target.value)}}
                    value={maxGuests}
                    >
                    </TextField>
                </Grid>
                <Grid item>
                    <TextField
                     style={{width:"50%"}}
                    label="Naziv"
                    type="text"
                    onChange={(e)=>{setName(e.target.value)}}
                    value={name}
                    >
                    </TextField>
                </Grid>
                <Grid item>
                    <TextField
                     style={{width:"50%"}}
                    label="Naziv Dvorane"
                    type="text"
                    onChange={(e)=>{setLokacija(e.target.value)}}
                    value={lokacija}
                    >
                    </TextField>
                </Grid>
                <Grid item>
                    <TextField
                     style={{width:"50%"}}
                    label="Predavac"
                    type="text"
                    onChange={(e)=>{setIDpredavaca(e.target.value)}}
                    required
                    value={IDPredavac}
                    >
                        TODO MORAJU BITI SAMO DOBRENI
                    </TextField>
                </Grid>
                <Grid spacing={5}>
                    <Button style={{marginTop:"10px"}} color="primary" variant="contained"   onClick={submitChanges}>Spremi</Button>
                </Grid>
            </Grid>
        </div>
    )
}

export default UrediRaspored
